import React, { Fragment, useState } from 'react';
import { Container } from 'react-bootstrap';
import HeaderLogged from '../../../../components/header_logged'
import Footer from '../../../../components/footer'
import Head from '../../../../components/head';
import Valor from '../../../../components/auth/licitacao/listar/form_valor'


function ValorLicScreen() {

    return (
        <Fragment>
            <Head titulo="Editando Valor da Licitação" />
            <HeaderLogged />
            <Container>
               <Valor />
            </Container>
            <Footer />
        </Fragment>
    );
}

export default ValorLicScreen;